import * as hooksLib from '../api/hooks.js';
import { fetchLoadable } from '../fetchLoadable.js';
import * as actionTypes from './actionTypes.js';
export const get = () => fetchLoadable(actionTypes.FETCH_HOOKS, hooksLib.getAll);
//# sourceMappingURL=actions.js.map